import { useState } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../supabaseClient";

export default function ChangePinScreen() {
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  async function savePin() {
    setError("");
    setSuccess("");

    if (pin.length !== 4 || isNaN(pin)) {
      setError("PIN moet 4 cijfers zijn.");
      return;
    }

    if (pin !== confirm) {
      setError("De PIN-codes komen niet overeen.");
      return;
    }

    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) return;

    const { error: updateError } = await supabase
      .from("teachers")
      .update({ pin_code: pin })
      .eq("id", user.id);

    if (updateError) {
      setError("Fout bij opslaan.");
      return;
    }

    setSuccess("PIN succesvol gewijzigd!");
    setTimeout(() => navigate("/dashboard"), 1000);
  }

  return (
    <div className="ct-page min-h-screen flex flex-col items-center justify-center p-6">
      <button
        onClick={() => navigate("/dashboard")}
        className="ct-button-secondary mb-6"
      >
        ← Terug
      </button>

      <div className="ct-surface w-full max-w-sm p-8 text-center">
      <p className="ct-eyebrow">Accountinstellingen</p>
      <h1 className="ct-modal-title mb-4">Nieuwe PIN instellen</h1>

      <input
        type="text"
        name="new-classroom-pin"
        inputMode="numeric"
        autoComplete="new-password"
        data-1p-ignore="true"
        data-lpignore="true"
        data-bwignore="true"
        data-form-type="other"
        placeholder="Nieuwe PIN"
        maxLength={4}
        value={pin}
        onChange={(e) => setPin(e.target.value)}
        className="ct-form-input ct-pin-input mb-3 w-64 text-center text-2xl tracking-widest"
      />

      <input
        type="text"
        name="confirm-classroom-pin"
        inputMode="numeric"
        autoComplete="new-password"
        data-1p-ignore="true"
        data-lpignore="true"
        data-bwignore="true"
        data-form-type="other"
        placeholder="Herhaal PIN"
        maxLength={4}
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        className="ct-form-input ct-pin-input mb-3 w-64 text-center text-2xl tracking-widest"
      />

      <button
        onClick={savePin}
        className="ct-button-primary mx-auto"
      >
        Opslaan
      </button>

      {error && <p className="text-red-600 mt-3">{error}</p>}
      {success && <p className="text-green-600 mt-3">{success}</p>}
      </div>
    </div>
  );
}
